export default __webpack_public_path__ + "static/media/defaultCustomer.19a3cf43.svg";